import { render, staticRenderFns } from "./VIPdialog.vue?vue&type=template&id=65e667aa&scoped=true"
import script from "./VIPdialog.vue?vue&type=script&lang=js"
export * from "./VIPdialog.vue?vue&type=script&lang=js"
import style0 from "./VIPdialog.vue?vue&type=style&index=0&id=65e667aa&prod&lang=scss&scoped=true"
import style1 from "./VIPdialog.vue?vue&type=style&index=1&id=65e667aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e667aa",
  null
  
)

export default component.exports